import { render, staticRenderFns } from "./ctx-btn.vue?vue&type=template&id=963fbffc&scoped=true&"
import script from "./ctx-btn.vue?vue&type=script&lang=ts&"
export * from "./ctx-btn.vue?vue&type=script&lang=ts&"
import style0 from "./ctx-btn.vue?vue&type=style&index=0&id=963fbffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963fbffc",
  null
  
)

export default component.exports